import React from 'react'
import Box from '@mui/material/Box'
import Fade from '@mui/material/Fade'
import { Typography, CircularProgress } from '@mui/material'
import FormInput from '../../../../components/Common/FormInput'
import StyledButton from '../../../../components/Button/Button'
interface FormErrors {
  question?: string
  answer?: string
}
interface HelpModalContentProps {
  open: boolean
  isEdit: boolean
  formValues: { question: string; answer: string }
  errorMsg: string
  isPending: boolean
  updateHelpPending: boolean
  handleClose: () => void
  handleChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void
  handleSubmit: () => void
  isFormValid: () => boolean
  errors: FormErrors
}

const HelpModalContent: React.FC<HelpModalContentProps> = ({
  open,
  isEdit,
  formValues,
  errorMsg,
  isPending,
  updateHelpPending,
  handleClose,
  handleChange,
  handleSubmit,
  isFormValid,
  errors,
}) => {
  return (
    <Fade in={open}>
      <Box className="sub-admin-modal-style">
        <div className="model-close" onClick={handleClose}>
          <img src="/icon/close icon.png" alt="Close" />
        </div>
        <Typography id="transition-modal-title" variant="h6" component="h2">
          <div className="create-subadmin">
            {isEdit ? 'Edit Help Question' : 'Create Help Question'}
          </div>
        </Typography>
        <form className="p-5">
          <div className="mt-6 w-full flex flex-col gap-8">
            <div className="flex flex-col gap-4">
              <FormInput
                label="Question"
                type="text"
                name="question"
                onChange={handleChange}
                value={formValues.question}
                required
                error={!!errors.question}
                helperText={errors.question}
              />
              <FormInput
                label="Answer"
                name="answer"
                value={formValues.answer}
                isMultiline={true}
                rows={5}
                maxRows={5}
                onChange={handleChange}
                error={!!errors.answer}
                helperText={errors.answer}
              />
              <p className="error-msg">{errorMsg}</p>
            </div>
            <StyledButton
              className={`h-14 w-32 !m-auto ${
                !isFormValid()
                  ? 'cursor-not-allowed bg-gray-200 text-gray-300 border border-gray-400'
                  : ''
              }`}
              onClick={handleSubmit}
              disabled={!isFormValid() || isPending || updateHelpPending}
            >
              {isPending || updateHelpPending ? (
                <CircularProgress className="!text-[#181a21] !text-2xl" />
              ) : isEdit ? (
                'Edit'
              ) : (
                'Save'
              )}
            </StyledButton>
          </div>
        </form>
      </Box>
    </Fade>
  )
}

export default HelpModalContent
